import { Component, Input, ViewChild, HostListener } from '@angular/core';
import { IRentabilidad } from '../../Entities/traslado.entities';
import { OverlayRef } from '@angular/cdk/overlay';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.sass'],
})
export class TooltipComponent {
  @Input() text: string;
  @Input() position = 'bottom';
  rentabilidadMensual: IRentabilidad;
  rentabilidadSemestral: IRentabilidad;
  rentabilidadAnual: IRentabilidad;
  overlayRef: OverlayRef;
  @ViewChild('insideElement') insideElement;

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    const clickedInside = this.insideElement.nativeElement.contains(
      event.target
    );
    if (!clickedInside && event.target.className !== 'view-rentabilidad') {
      this.hide();
    }
  }

  hide() {
    this.overlayRef.detach();
  }
}
